import type { ApiClient } from "@homesite/queries";
import { type ReactNode, createContext, useContext } from "react";

const ApiClientContext = createContext<ApiClient | null>(null);

export interface ApiClientProviderProps {
	client: ApiClient;
	children: ReactNode;
}

export function ApiClientProvider({
	client,
	children,
}: ApiClientProviderProps): ReactNode {
	return (
		<ApiClientContext.Provider value={client}>
			{children}
		</ApiClientContext.Provider>
	);
}

export function useApiClient(): ApiClient {
	const client = useContext(ApiClientContext);
	if (!client) {
		throw new Error("useApiClient must be used within an ApiClientProvider");
	}
	return client;
}
